import { Box, Paper, Tab, Tabs } from '@mui/material';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { PersitedDatePicker } from '../../../components/common';
import { useQuery } from '../../../hooks/UseQuery';
import ChildHeader from '../../../components/ui/ChildHeader';
import InputMuiCustom from '../../../components/common/inputs/InputMuiCustom';
import AnnuallyGraph from './dashBoard/AnnuallyGraph';
import AutocompleteMuiCustom from '../../../components/common/AutocompleteMuiCustom';

const MttrAndMtbfReportDashboardTabs = () => {
  const date = useQuery('date') || '';
  const [tabValue, setTabValue] = useState(0);
  const [machineData, setMachineData] = useState([]);
  const [data, setData] = useState({
    mttrData: [],
    mtbfData: [],
    target: 0,
  });
  const [machineValue, setMachineValue] = useState({ _id: '', machine_no: '' });
  const [target, setTarget] = useState(0);

  const fetchData = async () => {
    if (date && machineValue._id) {
      axios
        .get(
          `/api/downTimeAnalysisRoute/mttrAndMtbfReport/dashboard/?date=${date}&machineId=${machineValue._id}`,
        )
        .then((res) => {
          setData(res?.data);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  useEffect(() => {
    fetchData();
  }, [date, tabValue, machineValue]);

  useEffect(() => {
    axios
      .get('/api/machineRoutes/machine/ForAutocomplete')
      .then((res) => {
        setMachineData(res.data);
      })
      .catch((err) => console.log(err));
  }, []);

  return (
    <Box>
      <ChildHeader text="MTTR AND MTBF DASHBOARD GRAPH">
        <InputMuiCustom
          type="number"
          name="target"
          placeholder="Target"
          autoComplete="true"
          required={true}
          onChange={(e: any) => {
            setTarget(e.target.value);
          }}
          value={target || 0}
          sx={{ width: 300, marginLeft: 2, background: 'white' }}
        />
      </ChildHeader>
      <Paper elevation={2}>
        <Tabs
          value={tabValue}
          onChange={(_, newValue) => setTabValue(+newValue)}
          indicatorColor="primary"
          scrollButtons="auto"
          textColor="secondary"
          variant="fullWidth"
        >
          <Tab label="MTTR" />
          <Tab label="MTBF" />
        </Tabs>
      </Paper>
      <Box sx={{ margin: 2, display: 'flex', marginLeft: '25rem' }}>
        <PersitedDatePicker label="Search By Month" views={['year']} />
        <Box sx={{ marginLeft: 2, minWidth: 600 }}>
          <AutocompleteMuiCustom
            id="machine_no"
            label="Select Machine No."
            option_name="machine_no"
            arrayofObj={machineData}
            value={machineValue || ''}
            onChange={(e, value) => {
              if (value) setMachineValue(value);
            }}
          />
        </Box>
      </Box>
      <section>
        {tabValue === 0 && (
          <AnnuallyGraph apiData={data} target={target} tabValue={tabValue} />
        )}
        {tabValue === 1 && (
          <AnnuallyGraph apiData={data} target={target} tabValue={tabValue} />
        )}
      </section>
    </Box>
  );
};

export default MttrAndMtbfReportDashboardTabs;
